import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCheckbox,{staticClass:"d-inline-block my-0 py-0",attrs:{"dense":"","hide-details":""},model:{value:(_vm.activeValue),callback:function ($$v) {_vm.activeValue=$$v},expression:"activeValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }